const InsightViewOption = Object.freeze({
  UNIQUE_AUTHORS: 'UNIQUE_AUTHORS',
  POSTS: 'POSTS',
  NET_SENTIMENT: 'NET_SENTIMENT',
  IMPRESSIONS: 'IMPRESSIONS',
  PASSION_INTENSITY: 'PASSION_INTENSITY',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  AUTHORS: 'AUTHORS',
  BRANDS: 'BRANDS',
  HASHTAGS: 'HASHTAGS',
  MENTIONS: 'MENTIONS',
  POSITIVE_NEGATIVE: 'POSITIVE_NEGATIVE',
  POSITIVE_NEGATIVE_NEUTRAL: 'POSITIVE_NEGATIVE_NEUTRAL',
  TERMS: 'TERMS',
  THINGS: 'THINGS',
  MOST_MENTIONS: 'MOST_MENTIONS',
  MOST_FOLLOWERS: 'MOST_FOLLOWERS',
  PEOPLE: 'PEOPLE',
  ATTRIBUTES: 'ATTRIBUTES',
  EMOTIONS: 'EMOTIONS',
  BEHAVIORS: 'BEHAVIORS',
  SOURCES: 'SOURCES',
  MALE_FEMALE: 'MALE_FEMALE',
  ALL_SOURCES: 'ALL_SOURCES',
  BLOGS: 'BLOGS',
  FORUMS: 'FORUMS',
  SUBREDDITS: 'SUBREDDITS',
  NEWS: 'NEWS',
  EMOTIONS_BEHAVIORS_TO_THINGS: 'EMOTIONS_BEHAVIORS_TO_THINGS',
  THINGS_TO_EMOTIONS_BEHAVIORS: 'THINGS_TO_EMOTIONS_BEHAVIORS',
  BIOTEXT: 'BIOTEXT',
  ENGAGEMENTS: 'ENGAGEMENTS',
  ENGAGEMENT_RATIO_ONLY: 'ENGAGEMENT_RATIO_ONLY',
  MOST_ENGAGEMENT: 'MOST_ENGAGEMENT',
  SHARES: 'SHARES',
  LIKES: 'LIKES',
  COMMENTS: 'COMMENTS',
  VIEWS: 'VIEWS',
  DISLIKES: 'DISLIKES',
  SCORE: 'SCORE',
  LOGOS: 'LOGOS',
  DETECT_OBJECTS: 'DETECT_OBJECTS',
  DETECT_SCENES: 'DETECT_SCENES',
  DETECT_EMOTIONS: 'DETECT_EMOTIONS',
  AGE: 'AGE',
  INTERESTS: 'INTERESTS',
  PROFESSIONS: 'PROFESSIONS',
  ETHNICITY: 'ETHNICITY',
  EMOJIS_GROUP: 'EMOJIS_GROUP',
  EMOJIS_EMOTION: 'EMOJIS_EMOTION',
  EMOJIS_EMOJI: 'EMOJIS_EMOJI',
  PER_CAPITA: 'PER_CAPITA',
  PERCENT_SHARE: 'PERCENT_SHARE',
  HOUR_OF_DAY: 'HOUR_OF_DAY',
  DAY_OF_WEEK: 'DAY_OF_WEEK',
  HOUR_OF_WEEK: 'HOUR_OF_WEEK',
  LANGUAGE: 'LANGUAGE',
  TAGS: 'TAGS',
  DOC_HIERARCHY: 'DOC_HIERARCHY',
  PRODUCT_NAME: 'PRODUCT_NAME',
  OVERVIEW: 'OVERVIEW',
  OWNED_PARTNERED_EARNED: 'OWNED_PARTNERED_EARNED',
  CHANNELS: 'CHANNELS',
  STAR_RATINGS: 'STAR_RATINGS',
  SURVEY_SCORES: 'SURVEY_SCORES',
  BY_ENGAGEMENTS: 'BY_ENGAGEMENTS',
  BY_REPOSTS: 'BY_REPOSTS',
  BY_REPLIES: 'BY_REPLIES',
  BY_DATE: 'BY_DATE',
  BY_LINK_MENTIONS: 'BY_LINK_MENTIONS',
  BY_VIEWS: 'BY_VIEWS'
})
export default InsightViewOption
export type InsightViewOptionStrings = typeof InsightViewOption[keyof typeof InsightViewOption]
// RESERVE BELOW
